import { Icon } from "@opendash/icons";
import { Descriptions, Drawer, Space, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { ExportButton } from "../../../components/ExportButton";
import { ImageGallery } from "../../../components/ImageGallery";
import { SIV_DeliveryNotes } from "../../../parsegenerated";

type Props = {
  deliveryNote: SIV_DeliveryNotes | null;
  open: boolean;
  onClose: () => void;
};

export const DeliveryNoteDetailDrawer = observer((props: Props) => {
  const { deliveryNote, open, onClose } = props;
  const imageDirectory =
    (deliveryNote?.get("directory") as string | undefined) || undefined;

  // Prepare export data
  const exportData = [
    {
      Feld: "Nummer",
      Wert: deliveryNote?.no || "",
    },
    {
      Feld: "Datum",
      Wert: deliveryNote?.date
        ? dayjs(deliveryNote.date).format("DD.MM.YYYY")
        : "",
    },
    {
      Feld: "Lieferdatum",
      Wert: deliveryNote?.deliveryDate
        ? dayjs(deliveryNote.deliveryDate).format("DD.MM.YYYY")
        : "",
    },
    {
      Feld: "Transportart",
      Wert: deliveryNote?.transportType || "",
    },
    {
      Feld: "Betrieb",
      Wert: deliveryNote?.facility || "",
    },
    {
      Feld: "Los-Nr.",
      Wert: deliveryNote?.lotNo || "",
    },
    {
      Feld: "Transporteur",
      Wert: deliveryNote?.transportedBy || "",
    },
    {
      Feld: "Kennzeichen",
      Wert: deliveryNote?.licensePlate || "",
    },
    {
      Feld: "Xcellize-Nr.",
      Wert: deliveryNote?.xcellizeNo || "",
    },
  ];

  return (
    <Drawer
      title={
        <>
          <Icon icon="fa:file-alt" /> Lieferschein {deliveryNote?.no}
        </>
      }
      open={open}
      onClose={onClose}
      width="min(600px, 100vw)"
      extra={
        <Space>
          <ExportButton
            data={exportData}
            filename={`Lieferschein_${deliveryNote?.no || "export"}`}
          />
        </Space>
      }
    >
      {deliveryNote && (
        <>
          <Descriptions column={2} bordered size="small">
            <Descriptions.Item label="Nummer">
              {deliveryNote.no}
            </Descriptions.Item>
            <Descriptions.Item label="Datum">
              {deliveryNote.date
                ? dayjs(deliveryNote.date).format("DD.MM.YYYY")
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Lieferdatum">
              {deliveryNote.deliveryDate
                ? dayjs(deliveryNote.deliveryDate).format("DD.MM.YYYY")
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Transportart">
              {deliveryNote.transportType ? (
                <Tag color="blue">{deliveryNote.transportType}</Tag>
              ) : (
                "-"
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Betrieb">
              {deliveryNote.facility || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Los-Nr.">
              {deliveryNote.lotNo || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Transporteur" span={2}>
              {deliveryNote.transportedBy || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Kennzeichen">
              {deliveryNote.licensePlate || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Xcellize-Nr.">
              {deliveryNote.xcellizeNo || "-"}
            </Descriptions.Item>
            {deliveryNote.deliveryAddresses &&
              deliveryNote.deliveryAddresses.length > 0 && (
                <Descriptions.Item label="Lieferadressen" span={2}>
                  {deliveryNote.deliveryAddresses.map((addr, idx) => (
                    <div key={idx}>
                      <Typography.Text>{addr}</Typography.Text>
                    </div>
                  ))}
                </Descriptions.Item>
              )}

            {deliveryNote.remarks && deliveryNote.remarks.length > 0 && (
              <Descriptions.Item label="Bemerkungen" span={2}>
                {deliveryNote.remarks.map((remark, idx) => (
                  <div key={idx}>
                    <Typography.Text type="secondary" style={{ wordBreak: "break-word" }}>
                      {remark}
                    </Typography.Text>
                  </div>
                ))}
              </Descriptions.Item>
            )}

            {deliveryNote.deliveryAttributes && (
              <Descriptions.Item label="Merkmale" span={2}>
                <span style={{ wordBreak: "break-word" }}>
                  {deliveryNote.deliveryAttributes}
                </span>
              </Descriptions.Item>
            )}
          </Descriptions>

          <ImageGallery
            directory={imageDirectory}
            title="Bilder"
            height={170}
          />
        </>
      )}
    </Drawer>
  );
});
